import React from 'react';
import { Link } from 'react-router-dom';

// Mobile (APK) Register — single column, full width.
export default function RegisterMobile({ vm }) {
  const { form, set, busy, err, submit } = vm;
  return (
    <div className="auth-mobile">
      <div className="auth-mobile-brand">Mehfil by Smartify</div>
      <div className="muted auth-mobile-sub">Create your organiser account</div>
      <form onSubmit={submit} className="auth-mobile-form">
        <label className="field">Name
          <input type="text" value={form.name} placeholder="First name" onChange={(e) => set('name', e.target.value)} />
        </label>
        <label className="field">Surname
          <input type="text" value={form.surname} placeholder="Surname (optional)" onChange={(e) => set('surname', e.target.value)} />
        </label>
        <label className="field">Mobile Number
          <input type="tel" inputMode="numeric" maxLength={10} value={form.mobile} placeholder="10-digit mobile" onChange={(e) => set('mobile', e.target.value)} />
        </label>
        <label className="field">Organiser / Business Name
          <input type="text" value={form.organiser} placeholder="e.g. Smart Events Co" onChange={(e) => set('organiser', e.target.value)} />
        </label>
        <label className="field">Password
          <input type="password" value={form.password} placeholder="Choose a password" onChange={(e) => set('password', e.target.value)} />
        </label>
        <label className="field">Confirm Password
          <input type="password" value={form.confirm} placeholder="Re-enter password" onChange={(e) => set('confirm', e.target.value)} />
        </label>
        {err && <div className="auth-mobile-err">{err}</div>}
        <button className="btn primary auth-mobile-btn" disabled={busy}>
          {busy ? 'Creating account…' : 'Create Account'}
        </button>
      </form>
      <div className="auth-mobile-links">
        <Link to="/">Already have an account? Sign in</Link>
      </div>
    </div>
  );
}
